import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth/state'
import bridge from './bridge/state'
import commits from './commits/state'
import releases from './releases/state'
import bridgeInventory from './inventory/bridge/state'
import api from './api'

import userTypes from './userTypes'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    bridge,
    commits,
    releases,
    bridgeInventory
  },
  state: {
    user: null
  },
  getters: {
    user(state) {
      const user = state.user

      if(!user) {
        return user
      }

      user.type = userTypes.get(user.type)

      return state.user
    },
    isAdmin(state, getters) {
      if (!getters.user) {
        return false
      }
      return [userTypes.ADMIN, userTypes.SUPER_ADMIN].includes(getters.user.type)
    }
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    }
  },
  actions: {
    async fetchUser({ getters, commit }) {
      const response = await api.get('userinfo')
      const user = response.data

      commit('setUser', user)
      return user
    }
  }
})
